import ApiHandler from '@/api/base'

class MCPServerApiHandler extends ApiHandler {
  async revokeTokens() {
    const { data } = await this.http.post('/mcp/revoke-token')
    return data
  }
}

export default MCPServerApiHandler
